/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { get, map, toString, pickBy, identity, isEmpty } from "lodash";
import {
  IconButton,
  Pagination,
  Stack,
  // Chip,
  Menu,
  MenuItem,
  // Link as LinkMui,
  // CircularProgress,
  // Box,
  // Fade,
  // Typography
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Link } from "react-router-dom"

import Layout from "../../../components/layout/Layout"
import Table from "../../../components/form/Table";
import Toolbar from "./Toolbar";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";

import { getTransportBrand } from "../../../store/masters/thunk/transportBrand/getAll";
// import { deleteTransportBrand } from "../../../store/masters/thunk/transportBrand/delete"
// import { putTransportBrand } from "../../../store/masters/thunk/transportBrand/put"

const TransportBrand = () => {
  const [__] = useTranslation("transportBrand");
  const dispatch = useDispatch();
  const [filter, setFilter] = useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [selected, setSelected] = useState({})
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })

  const transportBrand = useSelector(state => state.masters.transportBrand);
  const put = useSelector(state => state.masters.transportBrand.put);
  const delet = useSelector(state => state.masters.transportBrand.delete);

  const getData = ({ page, filter }) => {
    const filters = { page, ...pickBy(filter, identity) }
    switch (get(filter, "isActive")) {
      case 1: filters.isActive = true; break;
      case 2: filters.isActive = false; break;
      default: break;
    }
    dispatch(getTransportBrand(filters))
  }

  const reload = () => getData({ page: 1, filter })

  useEffect(() => {
    setAnchorEl(false)
    getData({ page: 1, filter })
  }, [dispatch, JSON.stringify(filter)])


  const handleOpenMenu = (row) => (event) => {
    setSelected(row)
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setSelected({})
    setAnchorEl(null);
  };

  // const handleDelete = (id) => () => {
  //   dispatch(deleteTransportBrand({ id }))
  // }
  // const handleDisabled = (values) => () => {
  //   dispatch(putTransportBrand({ ...values, isActive: false }))
  // }

  //  --------- Delete -------------

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
  }

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert
    })
    }
    handleCloseMenu()
  }

  useEffect(() => {
    if (!transportBrand.isLoading) {
      if (get(delet, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "delet" }) }
      if (get(delet, "isReject", false)) { setError(get(delet, "error", {}), "delet") }
      if (get(put, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
      if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
    }
  }, [put, delet])

  const headTable = [
    {
      key: "description",
      label: __(`table.cols.description`),
      align: "left"
    },
    {
      key: "options",
      label: __(`table.cols.options`),
      align: "center",
      sx: { position: "sticky", width: 100, right: 0, pr: 1, background: "linear-gradient(90deg, hsla(0, 0%, 100%, 1) 0%, hsla(0, 0%, 87%, 1) 8px, hsla(0, 0%, 100%, 1) 8px, hsla(0, 0%, 100%, 1) 100%)" }
    },
  ]

  const dataTable = map(get(transportBrand, "data", []), (row, i) => ({
    ...row,
    options: <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)}><MoreVertIcon fontSize="inherit" /></IconButton>
  }))

  const onChangePagination = (e, page) => getData({ page, filter })

  return (
    <Layout
      propsToolbar={{
        title: __(`head.name`),
        code: null,
        btnLabel: null
      }}
    >
      <Toolbar setFilter={setFilter} __={__} getData={getData} reload={reload} isLoading={get(transportBrand, "isLoading", false)} />
      <Table headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        loading={get(transportBrand, "isLoading", false)}
      />
      <Stack sx={{ mt: 2 }} alignItems="flex-end">
        <Pagination
          count={get({}, "totalPage", 1)}
          page={get({}, "currentPage", 1)}
          onChange={onChangePagination}
          color="secondary"
          sx={{ "& li > button": { borderRadius: 1 } }}
        />
      </Stack>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Link to={toString(get(selected, "idTransportBrand"))}><MenuItem >{__(`table.menu.edit`)}</MenuItem></Link>
        {/* <MenuItem onClick={handleDisabled(selected)} disabled={get(put, "isLoading")} >
          <Box height={28} position="relative">
            <Fade in={get(put, "isLoading")}>
              <Box position="absolute" width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
                <CircularProgress color="primary" size={20} />
              </Box>
            </Fade>
            <Typography className='text-center w-full ' variant="bms" color={get(put, "isLoading") ? "text.slite" : "text.main"} >{__(`table.menu.deactivate`)}</Typography>
          </Box >
        </MenuItem> */}
        {/* <MenuItem onClick={handleDelete(get(selected, "idTransportBrand"))}>{__(`table.menu.delete`)}</MenuItem> */}
      </Menu>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
    </Layout>
  )
}

export default TransportBrand;


